import { render, staticRenderFns } from "./rightPreview.vue?vue&type=template&id=15a9e7d3&scoped=true"
import script from "./rightPreview.vue?vue&type=script&lang=js"
export * from "./rightPreview.vue?vue&type=script&lang=js"
import style0 from "./rightPreview.vue?vue&type=style&index=0&id=15a9e7d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a9e7d3",
  null
  
)

export default component.exports